module.exports = __webpack_public_path__ + "static/media/sga0002.ba6d3542.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/sgal/sga0002.jpg
// module id = 272
// module chunks = 0